import React, {ReactNode} from 'react';
import {Wrapper} from './BoxTabButton.styled';

interface IProps {
  children: ReactNode;
  isActive?: boolean;
  onClick: () => void;
}

const BoxTabButton = (props: IProps) => {
  const { onClick, children, isActive = false } = props;

  return (
    <Wrapper role="tab" onClick={onClick} isActive={isActive}>
        {children}
    </Wrapper>
  );
};

export default BoxTabButton;
